import { checkAvailabilitySlotDeletable, deleteAvailabilitySlots, getAvailabilitySlots, saveAvailabilitySlots } from "@/lib/api/availability"
import { AvailabilitySlot, ResourceAvailabilitySlot } from "@/lib/types/availability"
import { defineStore } from "pinia"

interface AvailabilityState {
    slots: ResourceAvailabilitySlot[]
    loading: boolean
}

export const useAvailabilitySlotsStore = defineStore('availabilitySlots', {
    state: (): AvailabilityState => ({
        slots: [],
        loading: false
    }),

    actions: {
        async fetchByResourceId(resourceId: string): Promise<void> {
            this.loading = true

            try {
                this.slots = [await getAvailabilitySlots(resourceId)] // TODO: support multiple resources
            } catch (err) {
                console.error(err)
                throw err
            } finally {
                this.loading = false
            }
        },

        async setAvailabilitySlots(availabilitySlots: ResourceAvailabilitySlot): Promise<ErrorMessage | void> {
            try {
                const res = await saveAvailabilitySlots(availabilitySlots)
                if (res && 'errorCode' in res) {
                    return res
                }
            } catch (err) {
                console.error(err)
                throw err
            } finally {
                this.loading = false
            }
        },

        async isAvailabilitySlotDeletable(availabilitySlot: AvailabilitySlot): Promise<boolean> {
            if (!availabilitySlot.id) {
                return true; // New slots without ID are always deletable
            }
            try {
                const res = await checkAvailabilitySlotDeletable(availabilitySlot.id)
                return res
            } catch (err) {
                console.error(err)
                throw err
            } finally {
                this.loading = false
            }
        },

        async deleteAvailabilitySlots(slotsToDelete: { id: string, reason?: string }[]): Promise<void> {
            try {
                await deleteAvailabilitySlots(slotsToDelete)
            } catch (err) {
                console.error(err)
                throw err
            } finally {
                this.loading = false
            }
        },
    },

    getters: {
        getSlotsByResourceId: (state) => {
            return (resourceId: string): ResourceAvailabilitySlot | undefined => {
                return state.slots.find(slot => slot.resourceId === resourceId)
            }
        }
    }
})